// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".x-ProjectManager a {\n  text-decoration: none;\n}\n", "",{"version":3,"sources":["webpack://./web/app/cad/projectManager/ProjectManager.less"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF","sourcesContent":[".root a {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "x-ProjectManager"
};
export default ___CSS_LOADER_EXPORT___;
